import SVGIconWrapper from "./SVGIconWrapper"

const IconSearchGlass = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 118.78 118.78"
        iconClass={`icon--search-glass ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M115.97 101.6l-27.3-27.3C93.3 66.9 96 58.17 96 48.8c0-26.5-21.5-48-48-48S0 22.3 0 48.8s21.5 48 48 48c10.2 0 19.64-3.2 27.4-8.6l27 26.97c1.87 1.88 4.33 2.8 6.78 2.8a9.6 9.6 0 0 0 6.8-2.8 9.609 9.609 0 0 0 0-13.57zM48 81.24c-17.92 0-32.45-14.52-32.45-32.44S30.08 16.36 48 16.36c17.9 0 32.44 14.52 32.44 32.44S65.9 81.24 48 81.24z" />
    </SVGIconWrapper>
)

export default IconSearchGlass